<template>
  <div class='orders'>
    <pager v-bind:items='companies || []'></pager>
    

    <div class="">
      <div class="d-inline-block">
        <b-btn size="sm" class="btn-primary" @click="$refs.editCompanyRef.showEditCompanyModal({}, true)" v-on:refresh="loadData">新建</b-btn>
      </div>
      <table class='table table-sm table-hover'>
        <thead class="thead-default">
          <th>名称</th>
          <th>公司代码</th>
          <th>发货信息</th>
          <th>账户余额</th>
          <th>告警阈值</th>
          <th>创建时间</th>
          <th v-if="isAdmin || isFinance">操作</th>
        </thead>
        <tbody>
          <tr v-for="company in companies"  :class="getPreChargeDisplayLevel(company.balance? company.balance.remained_amount: 0)">
            <td nowrap>{{company.nickname}}</td>
            <td nowrap>{{company.company_code}}</td>
            <td>
              <div class="text-center">{{company.sender_name}} {{company.sender_phone}}</div>
              <div class="small text-center">{{company.sender_address}}</div>
            </td>
            <td>{{company.balance? company.balance.remained_amount: 0}}元</td>
            <td>{{company.meta.credits}}元</td>
            <td><local-time :time="company.created_at"></local-time></td>
            <td v-if="isAdmin || isFinance || isCompany">
              <button class="btn btn-sm mx-1 btn-primary fa fa-pencil-square-o" @click="$refs.editCompanyRef.showEditCompanyModal(company)" v-on:refresh="loadData"></button>
              <button class="btn btn-sm mx-1 btn-primary" @click="$refs.preChargeRef.showPreChargeModal(company, '+')" v-if="isAdmin || isCompany">充值￥</button>
              <button class="btn btn-sm mx-1 btn-primary" @click="$refs.preChargeRef.showPreChargeModal(company, '-')" v-if="isFinance">扣款￥</button>
              <router-link class="btn btn-sm mx-1 btn-primary" role="button" :to="'/pre_charges?company_code=' + company.company_code">充值记录</router-link>
              <router-link class="btn btn-sm mx-1 btn-primary" role="button" :to="'/order_incomes?company_code=' + company.company_code">消费记录</router-link>
            </td>
          </tr>
        </tbody>  
      </table>
    </div>
    <create-pre-charge ref='preChargeRef' v-on:refresh="loadData"></create-pre-charge>
    <edit-company ref="editCompanyRef"></edit-company>

  </div>
</template>

<script>
import Pager from './_partial/Pager'
import CreatePreCharge from './_company/CreatePreCharge'
import LocalTime from '@/components/_small/LocalTime'
import EditCompany from '@/components/_company/EditCompany'
import CompanyMixin from '@/mixins/company'
import RoleMixin from '@/mixins/role'
import LoadDataMixin from '@/mixins/load_data'

function loadData () {
  let url = '/api/companies?detail=true'
  if (location.search) {
    url += '&' + location.search.slice(1, location.search.length)
  }

  this.$http.get(url).then(response => {
    this.companies = response.data.data
  })
  .catch(function (error) {
    console.log(error)
  })
}

export default {
  name: 'companies',
  mixins: [CompanyMixin, RoleMixin, LoadDataMixin],
  data () {
    return {
      'items': [],
      'hotCompany': {},
      companies: []
    }
  },
  mounted () {
    this.loadData()
  },
  components: {
    pager: Pager,
    'local-time': LocalTime,
    'create-pre-charge': CreatePreCharge,
    'edit-company': EditCompany
  },
  methods: {
    loadData
  }
}
</script>


<style lang='scss' scoped>
</style>